import * as types from './mutation-types'
import api from "@/modules/api";

const actions = {
  async getResetPasswordVerification({ commit }, { publicCode }) {
    try {
      commit(types.GET_RESET_PASSWORD_VERIFICATION_BEGIN)
      await api.resetPassword.getResetPasswordVerificationLink(publicCode)

      commit(types.GET_RESET_PASSWORD_VERIFICATION_SUCCESS)
    } catch (error) {
      commit(types.GET_RESET_PASSWORD_VERIFICATION_ERROR, error)
    }
  },
  async forgotPasswordVerification({ commit }, email) {
    try {
      commit(types.FORGOT_PASSWORD_VERIFICATION_BEGIN)
      const { data : { message } }  = await api.forgotPassword.forgotPasswordVerificationLink(email)
      commit(types.FORGOT_PASSWORD_VERIFICATION_SUCCESS, { message })
    } catch (error) {
      commit(types.FORGOT_PASSWORD_VERIFICATION_ERROR, error)
    }
  },
  async resetPasswordVerification({ commit }, data) {
    try {
      commit(types.RESET_PASSWORD_VERIFICATION_BEGIN)
      const { data : { message, email } }  = await api.resetPassword.resetPasswordVerificationLink(data)
      commit(types.RESET_PASSWORD_VERIFICATION_SUCCESS, { message, email })
    } catch (error) {
      commit(types.RESET_PASSWORD_VERIFICATION_ERROR, error)
    }
  }
}

export default actions
